import { variant as variants } from 'styled-system';
export const variant = ({
  color
}) => variants({
  prop: 'variant',
  variants: {
    primary: Object.assign({}, !color && {
      color: ({
        palette
      }) => {
        var _palette$primary;

        return palette == null ? void 0 : (_palette$primary = palette.primary) == null ? void 0 : _palette$primary.text;
      }
    }, {
      bg: ({
        palette
      }) => {
        var _palette$primary2;

        return palette == null ? void 0 : (_palette$primary2 = palette.primary) == null ? void 0 : _palette$primary2.base;
      }
    }),
    secondary: Object.assign({}, !color && {
      color: ({
        palette
      }) => {
        var _palette$text;

        return palette == null ? void 0 : (_palette$text = palette.text) == null ? void 0 : _palette$text.base;
      }
    }, {
      bg: ({
        baseColors
      }) => {
        var _baseColors$wildsand;

        return baseColors == null ? void 0 : (_baseColors$wildsand = baseColors.wildsand) == null ? void 0 : _baseColors$wildsand.base;
      }
    }),
    light: Object.assign({}, !color && {
      color: ({
        palette
      }) => {
        var _palette$text2;

        return palette == null ? void 0 : (_palette$text2 = palette.text) == null ? void 0 : _palette$text2.base;
      }
    }, {
      bg: ({
        palette
      }) => {
        var _palette$background;

        return palette == null ? void 0 : (_palette$background = palette.background) == null ? void 0 : _palette$background.white;
      }
    }),
    transparent: Object.assign({}, !color && {
      color: ({
        palette
      }) => {
        var _palette$text3;

        return palette == null ? void 0 : (_palette$text3 = palette.text) == null ? void 0 : _palette$text3.base;
      }
    }, {
      bg: 'transparent'
    })
  }
});